import { useState } from "react";
import api, { API } from "@/lib/api";
import { PageHeader } from "@/components/pcp";
import { FileArrowUp, DownloadSimple, CheckCircle, Warning } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function Importacao() {
  const [file, setFile] = useState(null);
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const downloadModelo = async () => {
    const token = localStorage.getItem("pcp_token");
    const r = await fetch(`${API}/importacao/modelo`, { headers: { Authorization: `Bearer ${token}` } });
    if (!r.ok) { toast.error("Erro"); return; }
    const blob = await r.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a"); a.href = url; a.download = "modelo_importacao.xlsx"; a.click();
    URL.revokeObjectURL(url);
  };

  const submit = async () => {
    if (!file) return;
    const fd = new FormData(); fd.append("file", file);
    setLoading(true);
    try {
      const { data } = await api.post("/importacao/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      setResult(data);
      toast.success("Importação concluída");
    } catch (e) {
      toast.error("Erro na importação");
    } finally { setLoading(false); }
  };

  return (
    <>
      <PageHeader testid="page-importacao" title="Importação Excel" subtitle="Importe OS e itens em lote via planilha" actions={<button className="btn btn-outline" onClick={downloadModelo} data-testid="btn-modelo"><DownloadSimple size={16} weight="bold" /> Baixar modelo</button>} />
      <div className="page-body" style={{ maxWidth: 720 }}>
        <div className="pcp-card" style={{ padding: 24 }}>
          <div style={{ marginBottom: 16 }}>
            <label className="label">Arquivo (.xlsx)</label>
            <input type="file" accept=".xlsx" onChange={(e) => setFile(e.target.files[0])} className="input" data-testid="import-file" />
          </div>
          <button className="btn btn-primary" onClick={submit} disabled={!file || loading} data-testid="btn-import"><FileArrowUp size={16} weight="bold" /> {loading ? "Importando…" : "Importar"}</button>

          {result && (
            <div style={{ marginTop: 24, padding: 16, background: "#FAFAFA", border: "1px solid #E4E4E7", borderRadius: 3 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 8, color: "#34C759", marginBottom: 8 }}>
                <CheckCircle size={20} weight="bold" /> <strong>Importação concluída</strong>
              </div>
              <div className="font-mono">Ordens criadas: {result.ordens_criadas}</div>
              <div className="font-mono">Itens criados: {result.itens_criados}</div>
              {result.erros.length > 0 && (
                <div style={{ marginTop: 12, color: "#DC2626" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 4 }}><Warning size={14} weight="bold" /> {result.erros.length} erros:</div>
                  <ul style={{ marginTop: 6, fontSize: "0.8rem" }}>{result.erros.slice(0, 20).map((e, i) => <li key={i}>{e}</li>)}</ul>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
}
